import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        width: "100%",
        minWidth: 150
    },
    blur: {
        filter: "blur(2px)"
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        width: "100%"
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'space-between'
    },
    thumbnail: {
        margin: theme.spacing(2),
        maxWidth: '100%',
        maxHeight: '100%',
        minWidth: 250,
        borderColor: theme.palette.secondary.main,
        border: 'solid 2px',
    },
    dropzoneInactive: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 400,
        minHeight: 400,
        margin: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: 'dashed 2px',
        textAlign: 'center'
    },
    dropzoneAccept: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 400,
        minHeight: 400,
        margin: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: 'solid 2px',
        textAlign: 'center'
    },
    dropzoneReject: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 400,
        minHeight: 400,
        margin: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.error.main,
        border: 'solid 2px',
        textAlign: 'center'
    },
    dragIcon: {
        height: 60,
        width: 60
    },
    transcodingProgress: {
        minWidth: 400,
        minHeight: 2,
    },
    thumbnailTranscoding: {
        margin: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 400,
        minHeight: 400,
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.error.main,
        border: 'solid 2px',
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold'
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'start',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        fontWeight: "bold",
        borderRadius: 5,
        padding: 10,
        margin: 5,
        marginLeft: 30,
        marginRight: 30,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"
    },
    warningContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'start',
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
        fontWeight: "bold",
        borderRadius: 5,
        padding: 10,
        margin: 5,
        marginLeft: 30,
        marginRight: 30,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"
    },
    downloadInfoContainer: {
        width: "100%",
        height: "100%",
        fontWeight: "bold",
        padding: 10,
        marginTop: 10,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.secondary,
        border: '1px solid',
        borderRadius: '5px',
    },
    warningIcon: {
        height: 40,
        width: 40,
        color: theme.palette.common.white,
        marginRight: 10
    },
    duplicateVideoRow: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between",
        alignItems: 'center'
    },
}));

export {useStyles};
